export const FETCH = 'RECOMMENDATION_TYPE/FETCH'
export const SET = 'RECOMMENDATION_TYPE/SET_DATA'
export const SET_LOADING = 'RECOMMENDATION_TYPE/SET_LOADING'

export const DROP_LIST = 'RECOMMENDATION_TYPE/DROP_LIST'
export const SET_FILTERS = 'RECOMMENDATION_TYPE/SET_FILTERS'

export const CLEAR_FILTERS = 'RECOMMENDATION_TYPE/CLEAR_FILTERS'
